import { getCalendarTestMode } from "@/logic/calendarTestModeManager";
import { shrpaApi } from "./axios";

// Types
import { SocialMediaPostData } from "@contracts/shareStop";

export default {
  async approveSocialPost(customerId: string, postId: string): Promise<SocialMediaPostData | null> {
    const uri = `/social/v2/${customerId}/posts/${postId}/approve`;
    const { data } = await shrpaApi.put<SocialMediaPostData>(uri);

    return data;
  },

  async unapproveSocialPost(customerId: string, postId: string): Promise<SocialMediaPostData | null> {
    const uri = `/social/v2/${customerId}/posts/${postId}/unapprove`;
    const { data } = await shrpaApi.put<SocialMediaPostData>(uri);

    return data;
  },

  async approveAll(customerId: string): Promise<Array<SocialMediaPostData>> {
    if (!customerId) throw new Error(`"customerId" value ( ${customerId} ) is incorrect`);

    const calendarId = getCalendarTestMode();
    const uri = `/social/v2/${customerId}/${calendarId}/posts/approve-all`;
    const { data } = await shrpaApi.put<Array<SocialMediaPostData>>(uri);

    return data;
  },

  async ratePost(customerId: string, postId: string, rating: number): Promise<SocialMediaPostData> {
    const uri = `/social/v2/${customerId}/posts/${postId}/rate`;
    const { data } = await shrpaApi.put<SocialMediaPostData>(uri, { rating });

    return data;
  },
};
